import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { Td } from "@itandi/itandi-bb-ui/Td";
import type React from "react";
import { StatusIcon } from "~/components/deprecated/StatusIcon";
import { formatHoursAndMinutes, formatMonthAndDay } from "~/utils/DateUtil";

type Props = {
	date: string | null;
	displayTime?: boolean;
};

export const DateCell: React.FC<Props> = ({
	date,
	displayTime = false
}: Props) => (
	<Td verticalAlign="Top">
		{date === null ? (
			<Flex>
				<Label size="s">未定</Label>
				<StatusIcon variant="Alert" />
			</Flex>
		) : (
			<Flex direction="column" gap={2}>
				<Label size="s">{formatMonthAndDay(date) ?? ""}</Label>
				{displayTime ? (
					<Label size="s">{formatHoursAndMinutes(date) ?? ""}</Label>
				) : null}
			</Flex>
		)}
	</Td>
);
